import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  mentionInput: {
    width: "100%",
    whiteSpace: "unset !important",
    minHeight: "45px !important",
    height: "auto",
    // maxHeight: 100,
    padding: "10px 12px",
    fontSize: "13px !important",
    "& div:first-child": {
      "& textarea": {
        fontFamily: "inherit",
        border: "solid 1px #EDEDED",
        borderRadius: 4,
        background: "#fff !important",
        borderBottom: "solid 3px #F3994E",
        transition: "0.5s",
        // overflowY: "auto !important",
        padding: "10px 12px",
        "&::-webkit-scrollbar": {
          width: "6px",
        },
        "&::-webkit-scrollbar-thumb": {
          background: "rgba(0, 0, 0, 0.2)",
          borderRadius: 5,
        },
        "&:focus": {
          boxShadow: "0px 1px 6px #ffd47099 !important",
          border: "solid 1px #F3994E !important",
          outline: "none",
          borderBottom: "solid 3px #F3994E",
        },
      },
    },
    "& ul": {
      background: "#fff",
      maxHeight: 200,
      overflow: "auto",
      borderRadius: 4,
      boxShadow:
        "0px 5px 5px -3px rgb(0 0 0 / 20%), 0px 8px 10px 1px rgb(0 0 0 / 14%), 0px 3px 14px 2px rgb(0 0 0 / 12%)",
      "& li": {
        padding: "5px 12px",
      },
      "& li[class$='focused']": {
        background: "#eee",
      },
    },
  },
}));

export default useStyles;
